import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Protagonist, Route, Space } from 'app/interfaces/api/types';
import {
  ContextService,
  LocationService,
  RouteService,
  SpaceService,
  StoryService
} from 'app/services';

import { DomHelper } from 'app/classes/dom-helper/dom-helper';

@Component({
  selector: 'app-single-space',
  templateUrl: './single-space.page.html',
  styleUrls: ['./single-space.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SingleSpacePage implements OnInit {
  @ViewChild('content', { read: ElementRef, static: false }) content: ElementRef;
  @ViewChild('contentContainer', { read: ElementRef, static: false }) contentContainer: ElementRef;

  public protagonists: Protagonist[] = [];
  public routes: Route[] = [];
  public space: Space;

  public didLoad: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private spaceService: SpaceService,
    private routeService: RouteService,
    private locationService: LocationService,
    private storyService: StoryService,
    private context: ContextService,
    private router: Router,
  ) {}

  ngOnInit(): void { }

  ionViewWillEnter(): void {
    this.reset();
  }

  async ionViewDidEnter(): Promise<void> {
    const slug: string = this.activatedRoute.snapshot.paramMap.get('slug');

    this.space = await this.spaceService.getBySlug(slug);

    for (const routeId of this.space.routes) {
      this.routes.push(await this.routeService.getByID(routeId));
    }

    this.protagonists = await this.spaceService.getProtagonists(this.space);

    DomHelper.whenReady(this.content.nativeElement).then(() => this.didLoad = true);
  }

  public async gotoFirstStory(route_id: number): Promise<void> {
    // @TODO: If more than one route exists, a route has to be chosen first
    const selectedRoute = await this.routeService.getByID(route_id);

    if (!selectedRoute || !selectedRoute.locations) {
      throw new Error(
        `No Route selected or no route available on space ${this.space.id}.`,
      );
    }
    this.context.setActiveRoute(selectedRoute);

    const location = await this.locationService.getByID(
      selectedRoute.locations[0],
    );
    if (!location) {
      throw new Error(`No locations available on route ${selectedRoute.id}.`);
    }

    const storyId = location.stories[0];
    if (!storyId) {
      throw new Error(`No story available on location ${location.id}.`);
    }

    /* Trigger window event for GA logs. See utils/listeners/firebase-analytics.ts. */
    document.dispatchEvent(new CustomEvent('rdi::startRoute', {
      detail: { slug: selectedRoute.slug }
    }));

    const story = await this.storyService.getByID(storyId);

    this.router.navigateByUrl(`/story/${story.slug}/map`);
  }

  /**
   * @unused
   */
  public openProtagonist(p: Protagonist): void {
    console.log(p);
  }

  private reset(): void {
    this.protagonists = [];
    this.routes = [];
    this.space = null;
    this.didLoad = false;
  }
}
